import * as React from 'react';
import { Center, ChakraProvider, ColorModeScript, Spinner } from '@chakra-ui/react';
import { CenteredLayout } from './components/common/Layout/CenteredLayout';
import { Theme } from './theme/Theme';
import { useCallback, useState } from 'react';
import { HashRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { DashboardView } from './views/admin/DashboardView';
import { AdminLoginView } from './views/admin/AdminLoginView';
import { AdminPrivateRoute } from './components/Admin/AdminPrivateRoute';

const OwnerManagementApp = () => {
  const ADMIN_DETAILS = 'ADMIN_DETAILS';
  const serializedState = sessionStorage.getItem(ADMIN_DETAILS);
  const adminDetailsFromSessionStorage =
    serializedState && JSON.parse(serializedState)?.alpdesk_token;
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [tokenState, setTokenState] = useState<string | null>(adminDetailsFromSessionStorage);

  const handleLoadingSpinner = useCallback((value: boolean) => {
    setIsLoading(value);
  }, []);

  const handleTokenState = useCallback((token: string | null) => {
    setTokenState(token);
  }, []);

  return (
    <React.StrictMode>
      <ColorModeScript />
      <ChakraProvider theme={Theme}>
        <CenteredLayout>
          <>
            {isLoading && (
              <Center minHeight={'100vh'}>
                <Spinner
                  thickness="4px"
                  speed="0.65s"
                  emptyColor="gray.200"
                  color="blue.500"
                  size="xl"
                />
              </Center>
            )}
            <Router>
              <Switch>
                <AdminPrivateRoute
                  path={'/admin'}
                  component={DashboardView}
                  tokenState={tokenState}
                  componentProps={{
                    handleLoadingSpinner: handleLoadingSpinner,
                    handleTokenState: handleTokenState,
                  }}
                />
                <Route path={'/'}>
                  {!tokenState ? (
                    <AdminLoginView
                      handleLoadingSpinner={handleLoadingSpinner}
                      handleTokenState={handleTokenState}
                    />
                  ) : (
                    <Redirect
                      to={{
                        pathname: '/admin',
                      }}
                    />
                  )}
                </Route>
              </Switch>
            </Router>
          </>
        </CenteredLayout>
      </ChakraProvider>
    </React.StrictMode>
  );
};

ReactDOM.render(
  <OwnerManagementApp />,
  document.getElementById('alpdesk-owner-management-app alpdesk-app'),
);
